import { ChakraFlex as Flex, ChakraImage as Image } from "@airhelp/react-ui-components";
import RichtextAdapter from "modules/storyblok/adapters/RichtextAdapter";
import type { PartnerCardProps } from "../PartnerCards.d";

export const PartnerCard = ({ content, logoUrl, logoBackgroundColor }: Omit<PartnerCardProps, "_uid">) => (
  <Flex
    flexDir="column"
    p={4}
    border="1px solid"
    borderColor="greyscale.300"
    borderRadius="lg"
    maxW={96}
    bg="greyscale.100"
  >
    <Flex bg={logoBackgroundColor} mb={10} minH={32} borderRadius="lg" justify="center" align="center">
      <Image src={logoUrl} />
    </Flex>
    <Flex flex={1} flexDir="column">
      <RichtextAdapter content={content} customStyles={{ heading: { mb: 5 }, paragraph: { flex: 1 } }} />
    </Flex>
  </Flex>
);
